"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = void 0;
const zod_1 = require("zod");
exports.user = zod_1.z.object({
    attributes: zod_1.z
        .object({
        firstName: zod_1.z.literal(true).optional(),
        lastName: zod_1.z.literal(true).optional(),
        id: zod_1.z.literal(true).optional(),
        email: zod_1.z.literal(true).optional(),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the user if specifying any at all',
    }),
});
/* eslint-enable @typescript-eslint/ban-types */
//# sourceMappingURL=user.js.map